import React, { useState } from 'react'
import CircularProgress from '@mui/material/CircularProgress';
import {
Box,
Button,
Grid,
Select,
Switch,
DeleteForeverIcon,
MenuItem ,
styled,
Paper,
Menu,
alpha,
GetCookie,
toast,
useEffect,
} from '../../Libraries/Post/GetAllPostRelatedToScreen/AllPosts/index'
import demoimg from '../../Assets/Images/DemoImageformedia.png'
import { IconButton, Divider,FormGroup,FormLabel } from "@mui/material";
import AccessTimeFilledIcon from "@mui/icons-material/AccessTimeFilled";
import DeleteIcon from "@mui/icons-material/Delete";
import { red } from "@mui/material/colors";
import EditIconbtn from "../../Assets/svgs/editIconbtn.svg";
import DeleteIconbtn from "@mui/icons-material/Delete";
import { FileUploader } from "react-drag-drop-files";
import {
    useGetSidebarContentMutation,
    useUpdateSidebarContentStatusMutation,
    useAddSidebarContentMutation,
    useUpdateSidebarContentMutation,
    useUpdateScreenConfigsMutation,
    useGetScreenConfigsMutation,
    useGetAllCountryMutation,
    useGetStatesByCountryMutation,
    useGetWeatherMutation,
    useAddSidebarBgImageMutation,
    useDeleteSidebarContentMutation,
} from '../../Redux/service/AllEmpData';
import SidebarScheduling from '../../Pages/Sidebar/SidebarScedule/ScreenWiseSidebarContentScheduling';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Radio,
    RadioGroup,
    FormControlLabel,
    FormControl,
    Checkbox,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import plusIcon from "../../Assets/svgs/primary-shape.svg";


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "transparent",
  ...theme.typography.body2,
  padding: theme.spacing(0),
  textAlign: "start",
  color: theme.palette.text.secondary,
  borderRadius: theme.spacing(0),
  boxShadow: "none",
}));
const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));
export default function SidebarContent({currentScreen}) {
    const [bgImageloading, setBgImageLoading] = useState(false); 
    const [loadingSidebar, setLoadingSidebar] = useState(false); 
    const [loadingSettings, setLoadingSettings] = useState(false);
    const [showSettingsCard, setShowSettingsCard] = useState(false);
    const [addModalOpen, setAddModalOpen] = useState(false);
    const [newContent, setNewContent] = useState({
        title: "",
        description: "",
    });
    const [isEditMode, setIsEditMode] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [addSidebarContent] = useAddSidebarContentMutation();
    const [updateSidebarContent] = useUpdateSidebarContentMutation();
    const [updateContentStatus] = useUpdateSidebarContentStatusMutation();
    const [getSidebarcontent] = useGetSidebarContentMutation();
    const [updateScreenConfigs] = useUpdateScreenConfigsMutation();
    const [getAllCountry] = useGetAllCountryMutation();
    const [getStatesByCountry] = useGetStatesByCountryMutation();
    const [uploadSidebarImage] = useAddSidebarBgImageMutation();
    const [deleteSidebarContent] = useDeleteSidebarContentMutation();
    const [weatherErrors, setWeatherErrors] = useState({ country: false, state: false });
    const [sidebardata , setsidebardata] = useState([]);
    const [data, setData] = useState({
        selectedSidebar: null,      
        showScheduleSidebarModal: false, 
    });
    const [bgType, setBgType] = useState("color"); 
    const [bgColor, setBgColor] = useState("#ffffff");
    const [bgImageUrl, setBgImageUrl] = useState("");
    const [headerWidgets, setHeaderWidgets] = useState({
    clock: false,
    weather: false,
    });
    const [bgFile, setBgFile] = useState(null);
    const [bgPreview, setBgPreview] = useState(null);

    const [weatherSettings, setWeatherSettings] = useState({
    country: "",
    state: "",
    });
    const [countries, setcountry] = useState([]); 
    const [states, setstates] = useState([]); 
    const [mainAreaSettings, setMainAreaSettings] = useState({
            font: "Arial",  
            size: "18",
            title: "",
            bgColor: "#ffffff",
            textColor: "#000000",
            });
    const fontFamilies = ["Cinzel", "Helvetica", "Hyokim", "montserrat", "opensans", "Oswald"];
    const fontSizes = ["16","18"];
    const [bodyStyling, setBodyStyling] = useState({
            subHeadingTitleSize: "16",
            subHeadingTitleColor: "#000000",
            subHeadingDescSize: "16",
            subHeadingDescColor: "#000000",
            });
    const fileTypes = ["JPG", "PNG", "JPEG"];
    const [getConfigsData] = useGetScreenConfigsMutation();
    const [getWeather] = useGetWeatherMutation();
    const [bgStatus, setBgStatus] = useState(false);
    const [bgThumb, setBgThumb] = useState(null);

    const handleSidebarStatus = async (e, index) => {
    try {
        const sidebarToUpdate = sidebardata.data[index];
        const currentStatus = sidebarToUpdate.txt_status === "true";   
        const newStatus = !currentStatus;                            

        const payload = new FormData();
        payload.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
        payload.append("security_token", await GetCookie("es_token"));
        payload.append("ser_screen_id", currentScreen.ser_screen_id);
        payload.append("ser_sidebar_id", sidebarToUpdate.ser_sidebar_id);
        payload.append("sidebar_status", newStatus.toString());      

        const res = await updateContentStatus(payload).unwrap();

        if (res.connection === "true" && res.status === "true") {
        toast.success(res.message);
        setsidebardata(prev => ({
            ...prev,
            data: prev.data.map((item, i) =>
            i === index
                ? { ...item, txt_status: newStatus.toString() }
                : item
            ),
        }));
        } else {
        toast.info(res.message);
        }
    } catch (error) {
        console.error(error);
        toast.error(error.status);
    }
    };

    const getSidebarContent = async () => {
        try {
            setLoadingSidebar(true);
            const formData = new FormData();
            formData.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
            formData.append("security_token", await GetCookie("es_token"));
            formData.append("ser_screen_id", currentScreen.ser_screen_id);
        
            const res = await getSidebarcontent(formData).unwrap();
            if (res.status === "true") {
                setsidebardata(res);
            }else {
                // toast.error(res.message);
            }
        }catch (error) {
            console.error(error);
            // toast.error(error.status);
            } finally {
            setLoadingSidebar(false);
        }
    };
    const handleSidebarSchedule = (sidebarItem) => {
        setData({
            selectedSidebar: sidebarItem,
            showScheduleSidebarModal: true,
            });
    };

    // Close schedule modal
    const handleScheduleModalClose = () => {
        setData({
            selectedSidebar: null,
            showScheduleSidebarModal: false,
        });
    };
    const handleEditSidebar = (row) => {
        setIsEditMode(true);
        setEditingId(row.ser_sidebar_id);

        setNewContent({
            title: row.txt_sidebar_title,
            description: row.txt_sidebar_description,
        });

        setAddModalOpen(true);
    };
    useEffect(() => {
        if (!currentScreen) return; 

        const fetchSidebarContent = async () => {
            setLoadingSidebar(true); 
            try {
            const formData = new FormData();
            formData.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
            formData.append("security_token", await GetCookie("es_token"));
            formData.append("ser_screen_id", currentScreen.ser_screen_id);

            const res = await getSidebarcontent(formData).unwrap();

            if (res.status === "true") {
                setsidebardata(res);
            }
            } catch (error) {
            console.error(error);
            } finally {
            setLoadingSidebar(false); 
            }
        };

        fetchSidebarContent();
        }, [currentScreen]);
    useEffect(() => {
        if (!showSettingsCard || !currentScreen) return;

        const fetchSidebarConfig = async () => {
            setLoadingSettings(true); 

            try {
            const countriesList = await getAllCountryData();
            await getScreenConfigsData(countriesList);
            } catch (error) {
            console.error(error);
            toast.error(error.status);
            } finally {
            setLoadingSettings(false); 
            }
        };

        fetchSidebarConfig();
        }, [showSettingsCard, currentScreen]);

   const handleAddSubmit = async () => {
        try {
            if (!newContent.title || !newContent.description) {
                toast.error("Please fill all fields");
                return;
            }
            const formData = new FormData();
            formData.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
            formData.append("security_token", await GetCookie("es_token"));
            formData.append("ser_screen_id", currentScreen.ser_screen_id);
            formData.append("txt_sidebar_title", newContent.title);
            formData.append("txt_sidebar_description", newContent.description);

            let res;

            if (isEditMode) {
                formData.append("ser_sidebar_id", editingId);
                res = await updateSidebarContent(formData).unwrap();
            } else {
                res = await addSidebarContent(formData).unwrap();
            }

            if (res.connection === "true" && res.status === "true") {
                toast.success(res.message);

                setAddModalOpen(false);
                setNewContent({ title: "", description: "" });
                setIsEditMode(false);
                setEditingId(null);

                getSidebarContent();
            } else {
                toast.error(res.message);
            }

        } catch (error) {
            console.error(error);
            toast.error(error.status);
            }
    };
    const handleDeleteSidebar = async(rowId) => {
        try {
            const formData = new FormData();
            formData.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
            formData.append("security_token", await GetCookie("es_token"));
            formData.append("ser_screen_id", currentScreen.ser_screen_id);
            formData.append("ser_sidebar_id", rowId);
            let res;

            if (isEditMode) {
                formData.append("ser_sidebar_id", editingId);
                res = await deleteSidebarContent(formData).unwrap();
            } else {
                res = await deleteSidebarContent(formData).unwrap();
            }

            if (res.connection === "true" && res.status === "true") {
                toast.success(res.message);
                getSidebarContent();
            } else {
                toast.error(res.message);
            }

        } catch (error) {
            console.error(error);
            toast.error(error.status);
            }
    }

   const handleConfigsettings = async () => {
        let selectedCountry = "";
        let selectedState = "";
        try {
            setLoadingSettings(true);
            let temperatureValue = "N/A"; 

            if (headerWidgets.weather) {
                let hasError = false;
                if (!weatherSettings.country) {
                    setWeatherErrors(prev => ({ ...prev, country: true }));
                    hasError = true;
                }
                if (!weatherSettings.state) {
                    setWeatherErrors(prev => ({ ...prev, state: true }));
                    hasError = true;
                }
                if (hasError) {
                    toast.error("Please select both country and state.");
                    setLoadingSettings(false);
                    return;
                }
            }

            if (headerWidgets.weather && weatherSettings.country && weatherSettings.state) {
                selectedState = states.find(s => s.value === weatherSettings.state)?.label || "";
                selectedCountry = countries.find(s => s.value === weatherSettings.country)?.label || "";

                const formData = new FormData();
                formData.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
                formData.append("security_token", await GetCookie("es_token"));
                formData.append("txt_location", selectedState);

                const res = await getWeather(formData).unwrap();

                if (res.status === 'true' && res.data) {
                    temperatureValue = res.data.temperature +'°C';
                    console.log(temperatureValue);
                } 
            }
            const sidebarBodyConfig = {
                title: {
                    size: bodyStyling.subHeadingTitleSize.replace("h", ""),
                    color: bodyStyling.subHeadingTitleColor,
                },
                description: {
                    size: bodyStyling.subHeadingDescSize.replace("h", ""),
                    color: bodyStyling.subHeadingDescColor,
                },
                background: {
                    value: bgType === "image" ? bgImageUrl : bgColor,
                    is_image: bgType === "image",
                },
                font: mainAreaSettings.font || "Arial",
            };

            const headerConfig = {
                clock: headerWidgets.clock,
                weather: {
                    enabled: headerWidgets.weather,
                    stats: "humidity",
                    temperature: temperatureValue,
                    country: selectedCountry || "",
                    state: selectedState || "",
                },
                    };

            const mainAreaConfig = {
                font: mainAreaSettings.font || "Roboto",
                size: mainAreaSettings.size,
                text: mainAreaSettings.title || "",
                bg_color: mainAreaSettings.bgColor,
                text_color: mainAreaSettings.textColor,
            };

            const configuration = {
                sidebar: {
                    body: sidebarBodyConfig,
                    header: headerConfig,
                    mainarea: mainAreaConfig,
                    font: mainAreaSettings.font || "Arial",
                },
            };

            const configForm = new FormData();
            configForm.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
            configForm.append("security_token", await GetCookie("es_token"));
            configForm.append("ser_screen_id", currentScreen.ser_screen_id);
            configForm.append("configuration", JSON.stringify(configuration));

            const resUpdate = await updateScreenConfigs(configForm).unwrap();

            if (resUpdate.connection === "true" && resUpdate.status === "true") {
                toast.success("Configuration updated successfully!");
            } else {
                toast.error(resUpdate.message || "Failed to update configuration");
            }

        } catch (error) {
            console.error(error);
            toast.error(error.status);
            }finally {
            setLoadingSettings(false);
        }
    };

       const getScreenConfigsData = async (countriesList) => {
            try {
                const formData = new FormData();
                formData.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
                formData.append("security_token", await GetCookie("es_token"));
                formData.append("ser_screen_id", currentScreen.ser_screen_id);

                const res = await getConfigsData(formData).unwrap();

                if (res.connection === "true" && res.status === "true" && res.data) {
                const config = res.data?.sidebar;
                if (!config) return;

                if (config.body?.background?.is_image && config.body.background.value) {
                    setBgImageUrl(config.body.background.value); 
                    setBgThumb(config.body.background.value);   
                    setBgStatus(true);                          
                    setBgType("image");                          
                } else {
                    setBgType("color");
                    setBgColor(config.body.background.value);
                    setBgStatus(false);
                    setBgImageUrl("");
                    setBgThumb(null);
                }

                if (config.header) {
                    setHeaderWidgets({
                        clock: !!config.header.clock,
                        weather: !!config.header.weather?.enabled,
                    });
                    if (config.header.weather?.enabled) {
                        const countryLabel = config.header.weather.country || "";
                        const stateLabel = config.header.weather.state || "";

                        const countryObj = countriesList.find(c => c.label === countryLabel);
                        const countryValue = countryObj ? countryObj.value : "";

                        setWeatherSettings(prev => ({ ...prev, country: countryValue }));

                        if (countryValue && stateLabel) {
                            const statesData = await getCountryState(countryValue);
                            const stateObj = statesData.find(s => s.label === stateLabel);
                            const stateValue = stateObj ? stateObj.value : "";
                            setWeatherSettings(prev => ({ ...prev, state: stateValue }));
                        }
                    }

                    if (config.body) {
                        setBodyStyling({
                            subHeadingTitleSize: config.body.title?.size || "16",
                            subHeadingTitleColor: config.body.title?.color || "#000000",
                            subHeadingDescSize: config.body.description?.size || "16",
                            subHeadingDescColor: config.body.description?.color || "#000000",
                        });
                        setBgThumb(config.body.background?.value || null);
                        setBgStatus(!!config.body.background?.is_image);
                    }

                     if (config.mainarea) {
                        setMainAreaSettings({
                            font: config.mainarea.font || "Arial",
                            size: config.mainarea.size || "18",
                            title: config.mainarea.text || "",
                            bgColor: config.mainarea.bg_color || "#ffffff",
                            textColor: config.mainarea.text_color || "#000000",
                        });
                    }
                }


                }
            } catch (error) {
            console.error(error);
            toast.error(error.status);
            }
            };

           const handleChangebgImg = async (file) => {
                if (!file) return;
                setBgImageLoading(true);

                const formData = new FormData();
                formData.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
                formData.append("security_token", await GetCookie("es_token"));
                formData.append("screenId", currentScreen.ser_screen_id);

                // IMPORTANT — force key name
                formData.append("sidebarFile", file, file.name);

                const res = await uploadSidebarImage(formData).unwrap();
                if(res.status === 'true'){
                    setBgThumb(res.file_url);
                    setBgImageUrl(res.file_url);
                    setBgImageLoading(false);

                }
            };


        const getAllCountryData = async () => {
            try {
                const formData = new FormData();
                formData.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
                formData.append("security_token", await GetCookie("es_token"));

                const res = await getAllCountry(formData).unwrap();

                if (res.connection === "true" && res.status === "true" && res.data) {
                setcountry(res.data);          
                return res.data;               
                }
                return [];
            } catch (error) {
            console.error(error);
            toast.error(error.status);
            return [];
            }
            };
        const getCountryState = async (countryId) => {
            try {
                const formData = new FormData();
                formData.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
                formData.append("security_token", await GetCookie("es_token"));
                formData.append("country_id", countryId);

                    const res = await getStatesByCountry(formData).unwrap();

                if (res.connection === "true" && res.status === "true" && res.data) {
                setstates(res.data);
                return res.data;   
                }
                return [];
            } catch (error) {
                console.error(error);
                toast.error(error.status);
                 return [];
                }
        };

    const handleBgChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        setBgFile(file);
        setBgPreview(URL.createObjectURL(file));
        };

        const handleRemoveBg = () => {
        setBgFile(null);
        setBgPreview(null);
        };

        const handleSaveBg = async () => {
        if (!bgFile) return;

        try {
            const formData = new FormData();
            formData.append("txt_customer_id", localStorage.getItem("txt_customer_id"));
            formData.append("security_token", await GetCookie("es_token"));
            formData.append("upload_type", "File");
            formData.append("sidebarFile", bgFile);
            formData.append("screenId", currentScreen.ser_screen_id);

            const res = await uploadSidebarImage(formData).unwrap(); // use your API mutation

            if (res.connection === "true" && res.status === "true" && res.data?.url) {
            setBgPreview(res.data.url);
            toast.success("Sidebar background uploaded successfully!");
            setBgFile(null);
            } else {
            toast.error(res.message || "Upload failed");
            }
        } catch (error) {
            console.error(error);
            toast.error(error.status);
            }
        };

        const handleChangebgImgStatus = (e) => {
            const checked = e.target.checked;
            setBgStatus(checked);

            if (!checked) {
                setBgType("color");
            } else {
                setBgType("image");
            }
        };
        const handleTitleChange = (e) => {
            const value = e.target.value;

            // const regex = /^[a-zA-Z0-9 ]*$/;
            // const regex = /^[a-zA-Z0-9 :()\/\-,.'""]*$/;
            // const regex = /^[a-zA-Z0-9\s:()\/\-,.'"!?]*$/;

            // if (regex.test(value)) {
                setNewContent({ ...newContent, title: value });
            // }
        }
        const handleDescriptionChange = (e) => {
            const value = e.target.value;

            // const regex = /^[a-zA-Z0-9 ]*$/;
            // const regex = /^[a-zA-Z0-9 :()\/\-,.'""]*$/;
            // const regex = /^[a-zA-Z0-9\s:()\/\-,.'"!?]*$/;

            // if (regex.test(value)) {
                setNewContent({ ...newContent, description: value });
            // }
        };
  return (
     <>
    <Box sx={{ flexGrow: 1}}>
    <Grid
        container
        spacing={0}
        className="flex align-items-center bg bg-white py-4 px-4"
        sx={{ borderRadius: '16px'}}
    >

        <Box
            sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 2,
            }}
            >
            <h5 style={{ fontWeight: 600, color: "#365262", letterSpacing: '0px' }}>
                Sidebar Content
            </h5>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <span style={{ fontSize: "13px", color: "#666" }}>Settings</span>
                <Switch
                size="small"
                checked={showSettingsCard}
                onChange={(e) => setShowSettingsCard(e.target.checked)}
                />
            </Box>
            </Box>

            {loadingSidebar ? (
                <Box
                    sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "200px", // adjust height as needed
                    }}
                >
                    <div style={{ width: 80, height: 80 }}>
                        <CircularProgress />
                    </div>
                </Box>
            ) : (
                <>
                    <table className="table align-middle bg-white" >
                    <thead className="bg-light fs-14" >
                        <tr>
                        <th
                            style={{
                            backgroundColor: "#1A75E8",
                            color: "white",
                            alignItems: "center",
                            textAlign: "center",
                            }}
                        >
                            Title
                        </th>
                        <th
                            style={{
                            backgroundColor: "#1A75E8",
                            color: "white",
                            alignItems: "center",
                            textAlign: "center",
                            }}
                        >
                            Description
                        </th>
                        <th
                            style={{
                            backgroundColor: "#1A75E8",
                            color: "white",
                            alignItems: "center",
                            textAlign: "center",
                            }}
                        >
                            Status
                        </th>
                        <th
                            style={{
                            backgroundColor: "#1A75E8",
                            color: "white",
                            alignItems: "center",
                            textAlign: "center",
                            }}
                        >
                            Schedule
                        </th>
                        <th
                            style={{
                            backgroundColor: "#1A75E8",
                            color: "white",
                            alignItems: "center",
                            textAlign: "center",
                            }}
                        >
                            Action
                        </th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(sidebardata?.data) && sidebardata.data.length > 0 ? (
                            sidebardata.data.map((row, index) => (
                            <tr key={row.ser_sidebar_id}>
                            <td
                                style={{
                                width: "25%",
                                alignItems: "center",
                                textAlign: "center",
                                }}
                            >
                                <h6 className="mb-1" style={{ fontSize: "14px", letterSpacing: "0px" }}>
                                {row.txt_sidebar_title?.length > 10
                                    ? row.txt_sidebar_title.substring(0, 10) + "..."
                                    : row.txt_sidebar_title}
                                </h6>
                            </td>
                                <td
                                    style={{
                                        width: "20%",
                                        alignItems: "center",
                                        textAlign: "center",
                                    }}
                                    >
                                    <h6 style={{ fontSize: "14px", letterSpacing: "0px" }}>
                                        {row.txt_sidebar_description?.length > 10
                                        ? row.txt_sidebar_description.substring(0, 20) + "..."
                                        : row.txt_sidebar_description}
                                    </h6>
                                    </td>

                                <td className="text-center">
                                <Switch
                                    // checked={row.txt_status}
                                    checked={row.txt_status === "true"} 
                                    inputProps={{ "aria-label": "controlled" }}
                                    onChange={(e) => handleSidebarStatus(e, index)}
                                />
                                </td>

                                <td className="text-center">
                                    <IconButton onClick={() => handleSidebarSchedule(row)}>
                                        <AccessTimeFilledIcon
                                            color={row.is_scheduled == "true" ? "primary" : "action"}
                                        />
                                    </IconButton>
                                </td>
                                <td
                                    style={{
                                    width: "20%",
                                    alignItems: "center",
                                    textAlign: "center",
                                    }}
                                >
                                    <IconButton>
                                        <IconButton 
                                        onClick={() => handleEditSidebar(row)}
                                        >
                                            <EditIcon sx={{ color: '#1976d2' }} />
                                        </IconButton>
                                    </IconButton>
                                    <IconButton>
                                        <DeleteIconbtn
                                        onClick={(e) => handleDeleteSidebar(row.ser_sidebar_id)}
                                        sx={{ color: red[900] }}
                                        />
                                    </IconButton>
                                </td>
                            </tr>
                            ))
                        ) : (
                            <tr>
                            <td colSpan={4} className="text-center text-muted">
                                No data found
                            </td>
                            </tr>
                        )}
                        </tbody>
                            
                    </table>
                    <Box className="flex justify-content-center" sx={{width: '100%'}}>
                            <Button
                            className="capitalized fw-bold"
                            variant="contained"
                            startIcon={
                            <img
                                src={plusIcon}
                                alt="plus"
                                className="plus-icon"
                                style={{
                                width: "18px",
                                height: "18px",
                                objectFit: "contain",
                                transition: "0.3s ease",
                                }}
                            />
                            }
                            sx={{
                                maxHeight: "48px",
                                height: "40px",
                                width: "250px",
                                fontWeight: "bold",
                                textTransform: "none",
                                borderRadius: "8px",
                                background: "#1A75E829",
                                boxShadow: "none",
                                color: "#1A75E8",
                                fontSize: "15px",
                                transition: "0.3s ease",
                                marginTop:"10px",

                                "&:hover": {
                                backgroundColor: "#1A75E8",
                                color: "#ffffff",
                                boxShadow: "none",
                                },

                                "&:hover .plus-icon": {
                                filter: "brightness(0) invert(1)",
                                },
                            }}
                            onClick={() => setAddModalOpen(true)}
                            >
                                Add Content
                            </Button>
                    </Box>
                </>

            )}         
            </Grid>
            </Box>
            {/* Settings White Card */}
            {showSettingsCard && (
            <Box sx={{ mt: 2 }}>
                <Grid
                container
                className="bg bg-white py-4 px-4"
                sx={{ borderRadius: "16px" }}
                >
                <Grid item xs={12}>
                    <h5 style={{ fontWeight: 600, color: "#365262", letterSpacing: '0px' }}>
                    Sidebar Configurations 
                    </h5>
                </Grid>
                {loadingSettings ? (
                            <Box
                                sx={{
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    minHeight: "200px", 
                                }}
                            >
                                <div style={{ width: 80, height: 80 }}>
                                    <CircularProgress />
                                </div>
                            </Box>
                ) : (
                    <>
                {/* Radio Buttons */}
                <Grid item xs={12}sx={{ mt: 2, border: '1px solid #d2cece', padding:'3%', borderRadius:'12px'}} >
                    <Grid item xs={12} >
                        <h6 style={{ fontWeight: 600, color: "#636161", letterSpacing:'0px' }}>
                        Background Setting
                        </h6>
                        <FormControl>
                        <RadioGroup
                            row
                            value={bgType}
                            onChange={(e) => setBgType(e.target.value)}
                        >
                            <FormControlLabel
                            value="color"
                            control={<Radio size="small" />}
                            label="Background Color"
                            sx={{
                                "& .MuiFormControlLabel-label": {
                                fontSize: "14px",
                                },
                            }}
                            />
                            <FormControlLabel
                            value="image"
                            control={<Radio size="small" />}
                            label="Background Image"
                            sx={{
                                "& .MuiFormControlLabel-label": {
                                fontSize: "14px",
                                },
                            }}
                            />
                        </RadioGroup>
                        </FormControl>
                    </Grid>
                    
                    {/* If Color Selected */}
                    {bgType === "color" && (
                        <Grid item xs={12} sx={{ mt: 2 }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1}}>
                            <input
                            type="color"
                            value={bgColor}
                            onChange={(e) => setBgColor(e.target.value)}
                            style={{
                                width: "25px",
                                height: "25px", 
                                border: 'none',
                                cursor: "pointer", 
                                padding: "0px", 
                                background: "#ffffff",
                                boxShadow: "0 0 8px rgb(193 195 198 / 70%) "
                                }}
                            />
                            <TextField
                            value={bgColor}
                            size="small"
                            onChange={(e) => setBgColor(e.target.value)}
                            label="Color Code"
                            sx={{
                                fontSize: "14px",
                                width: "100px",   
                                "& .MuiInputBase-root": {
                                height: "35px", 
                                fontSize: "14px",
                                },
                                "& .MuiInputLabel-root": {
                                fontSize: "12px",  
                                },
                            }}
                            />
                        </Box>
                        </Grid>
                    )}
                {/* If Image Selected */}
                {bgType === "image" && (
                    <Grid item xs={12} sx={{ mt: 2 }}>

                    <Grid container spacing={2} alignItems="center">

                        {/* Upload */}
                        <Grid item xs={6}>
                        <div className="sidebarbackgroundimgcustomization">
                            <FileUploader
                                handleChange={handleChangebgImg}
                                name="file"
                                types={fileTypes}
                                />
                        </div>

                        <p className="mt-1" style={{ fontSize: "13px" }}>
                            152 × 152 JPG or PNG recommended
                        </p>
                        </Grid>



                        {/* Small Thumbnail */}
                        {bgImageloading ? (
                            <Grid item xs={2}>
                            <CircularProgress/>
                            </Grid>
                        ):(
                        <Grid item xs={2}>
                        {bgThumb && (
                            <img
                            src={bgThumb}
                            alt="preview"
                            width="50"
                            height="50"
                            style={{ borderRadius: "8px", objectFit: "contain" }}
                            />
                        )}
                        </Grid>
                        )}

                    </Grid>

                    </Grid>
                    )}


                </Grid>

                
                {/* Header Styling */}
                <Grid item xs={12} sx={{ mt: 2, border: '1px solid #d2cece', padding:'3%', borderRadius:'12px'}}>
                    <h6 style={{ fontWeight: 600, color: "#636161", letterSpacing:'0px' }}>
                    Header Styling
                    </h6>

                    {/* Clock & Weather Checkboxes */}
                    <Grid item xs={12} sx={{ mt: 1, display: "flex", flexDirection: "row", gap: 1 }}>
                    <FormControlLabel
                        control={
                        <Checkbox
                            size="small"
                            checked={headerWidgets.clock}
                            onChange={(e) =>
                            setHeaderWidgets({
                                ...headerWidgets,
                                clock: e.target.checked,
                            })
                            }

                        />
                        }
                        label="Clock Widget"
                        sx={{
                            "& .MuiFormControlLabel-label": {
                                fontSize: "14px",
                            },
                        }}
                        
                    />

                    <FormControlLabel
                        control={
                        <Checkbox
                            size="small"
                            checked={headerWidgets.weather}
                            onChange={(e) =>
                            setHeaderWidgets({
                                ...headerWidgets,
                                weather: e.target.checked,
                            })
                            }
                            
                        />
                        }
                        label="Weather Widget"
                        sx={{
                            "& .MuiFormControlLabel-label": {
                                fontSize: "14px",
                            },
                        }}
                    />
                    </Grid>

                    {/* Conditional Weather Settings */}

                    {headerWidgets.weather && (
                    <Grid
                        item
                        xs={12}
                        sx={{
                            mt: 1,
                            display: "flex",
                            flexDirection: "row",
                            gap: 1,
                            width: "100%", 
                        }}
                        >
                        <Box
                            sx={{
                            mt: 1,
                            display: "flex",
                            gap: 2,
                            flexWrap: "nowrap", 
                            width: "100%",  
                            }}
                        >
                        {/* Select Country */}
                            <TextField
                            select
                            size="small"
                            label="Select Country"
                            error={weatherErrors.country}
                            value={weatherSettings.country || ""} 
                            // onChange={async (e) => {
                            //     const selectedCountry = e.target.value;

                            //     setWeatherSettings(prev => ({
                            //     ...prev,
                            //     country: selectedCountry,
                            //     state: "",
                            //     }));

                            //     if (selectedCountry) {
                            //     await getCountryState(selectedCountry); 
                            //     }
                            // }}
                            onChange={async (e) => {
                                const selectedCountry = e.target.value;
                                setWeatherSettings(prev => ({ ...prev, country: selectedCountry, state: "" }));
                                setWeatherErrors(prev => ({ ...prev, country: false })); 
                                if (selectedCountry) {
                                    await getCountryState(selectedCountry);
                                }
                            }}
                            sx={{
                                fontSize: "14px",
                                flex: 1,
                                "& .MuiInputBase-root": {
                                height: "35px",
                                fontSize: "14px",
                                },
                                "& .MuiInputLabel-root": {
                                fontSize: "12px",
                                },
                            }}
                            >
                            {countries.length > 0 ? (
                                countries.map((country) => (
                                <MenuItem key={country.value} value={country.value}>
                                    {country.label}
                                </MenuItem>
                                ))
                            ) : (
                                <MenuItem value="" disabled>
                                Loading countries...
                                </MenuItem>
                            )}
                            </TextField>
                            {/* Select State */}
                            <TextField
                            select
                            size="small"
                            label="Select State"
                            value={weatherSettings.state}
                            error={weatherErrors.state}
                            // onChange={(e) =>
                            //     setWeatherSettings({
                            //     ...weatherSettings,
                            //     state: e.target.value,
                            //     })
                            // }
                            onChange={(e) => {
                                setWeatherSettings({ ...weatherSettings, state: e.target.value });
                                setWeatherErrors(prev => ({ ...prev, state: false })); // Clear state error
                                }}
                            sx={{
                                fontSize: "14px",
                                flex: 1,
                                "& .MuiInputBase-root": {
                                height: "35px",
                                fontSize: "14px",
                                },
                                "& .MuiInputLabel-root": {
                                fontSize: "12px",
                                },
                            }}
                            disabled={!weatherSettings.country} 
                            >
                            {states.map((state) => (
                                <MenuItem 
                                key={state.value} value={state.value}
                                >
                                {state.label}
                                </MenuItem>
                            ))}
                            </TextField>
                        </Box>
                        </Grid>

                    )}
                </Grid>
                {/* Main Area Styling */}

                <Grid item xs={12}  sx={{ mt: 2, border: '1px solid #d2cece', padding:'3%', borderRadius:'12px'}}>
                    <Grid item xs={12} >
                    <h6 style={{ fontWeight: 600, color: "#636161", letterSpacing:'0px' }}>
                        Main Area Styling
                    </h6>
                    </Grid>

                    <Grid container spacing={2} sx={{ mt: 1 }}>

                    {/* 3. Main Area Title */}
                    <Grid item xs={12} sm={6} sx={{gap: '2%'}}>
                        {/* <TextField
                        label="Main Area Title"
                        size="small"
                        value={mainAreaSettings.title}
                        onChange={(e) =>
                            setMainAreaSettings({ ...mainAreaSettings, title: e.target.value })
                        }
                        fullWidth
                        sx={{
                            fontSize: "14px",
                            flex: 1,
                            "& .MuiInputBase-root": {
                            height: "35px",
                            fontSize: "14px",
                            },
                            "& .MuiInputLabel-root": {
                            fontSize: "12px",
                            },
                        }}
                        /> */}
                        <TextField
                            label="Main Area Title"
                            size="small"
                            value={mainAreaSettings.title}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (value.length <= 25) {
                                setMainAreaSettings({
                                    ...mainAreaSettings,
                                    title: value,
                                });
                                }
                            }}
                            inputProps={{
                                maxLength: 25, 
                            }}
                            fullWidth
                            sx={{
                                fontSize: "14px",
                                flex: 1,
                                "& .MuiInputBase-root": {
                                height: "35px",
                                fontSize: "14px",
                                },
                                "& .MuiInputLabel-root": {
                                fontSize: "12px",
                                },
                            }}
                            />
                    </Grid>
                    {/* 1. Font Family */}
                    <Grid item xs={12} sm={6}>
                        <TextField
                        select
                        label="Font Family"
                        size="small"
                        value={mainAreaSettings.font}
                        onChange={(e) =>
                            setMainAreaSettings({ ...mainAreaSettings, font: e.target.value })
                        }
                        fullWidth
                        sx={{
                            fontSize: "14px",
                            flex: 1,
                            "& .MuiInputBase-root": {
                            height: "35px",
                            fontSize: "14px",
                            },
                            "& .MuiInputLabel-root": {
                            fontSize: "12px",
                            },
                        }}
                        >
                        {fontFamilies.map((font) => (
                            <MenuItem key={font} value={font}>
                                {font}
                            </MenuItem>
                        ))}
                        </TextField>
                    </Grid>

                    {/* 2. Font Size */}
                    <Grid item xs={12} sm={6}>
                        <TextField
                        select
                        label="Font Size"
                        size="small"
                        value={mainAreaSettings.size}
                        onChange={(e) =>
                            setMainAreaSettings({ ...mainAreaSettings, size: e.target.value })
                        }
                        fullWidth
                        sx={{
                            fontSize: "14px",
                            flex: 1,
                            "& .MuiInputBase-root": {
                            height: "35px",
                            fontSize: "14px",
                            },
                            "& .MuiInputLabel-root": {
                            fontSize: "12px",
                            },
                        }}
                        >
                        {fontSizes.map((size) => (
                            <MenuItem key={size} value={size}>
                                {size.toUpperCase()}
                            </MenuItem>
                        ))}
                        </TextField>
                    </Grid>
                    {/* 4. Background Color */}
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <input
                            type="color"
                            value={mainAreaSettings.bgColor}
                            onChange={(e) =>
                                setMainAreaSettings({ ...mainAreaSettings, bgColor: e.target.value })
                            }
                            style={{
                              width: "25px",
                              height: "25px", 
                              border: 'none',
                              cursor: "pointer", 
                              padding: "0px", 
                              background: "#ffffff",
                              boxShadow: "0 0 8px rgb(193 195 198 / 70%) "
                            }}
                            />
                        <TextField
                            label="Background Color"
                            size="small"
                            value={mainAreaSettings.bgColor}
                            onChange={(e) =>
                            setMainAreaSettings({ ...mainAreaSettings, bgColor: e.target.value })
                            }
                            fullWidth
                            sx={{
                            fontSize: "14px",
                            flex: 1,
                            "& .MuiInputBase-root": {
                            height: "35px",
                            fontSize: "14px",
                            },
                            "& .MuiInputLabel-root": {
                            fontSize: "12px",
                            },
                        }}
                        />
                        </Box>
                    </Grid>

                    {/* 5. Text Color */}
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <input
                            type="color"
                            value={mainAreaSettings.textColor}
                            onChange={(e) =>
                            setMainAreaSettings({ ...mainAreaSettings, textColor: e.target.value })
                            }
                            style={{
                              width: "25px",
                              height: "25px", 
                              border: 'none',
                              cursor: "pointer", 
                              padding: "0px", 
                              background: "#ffffff",
                              boxShadow: "0 0 8px rgb(193 195 198 / 70%) "
                            }}
                        />
                        <TextField
                            label="Text Color"
                            size="small"
                            value={mainAreaSettings.textColor}
                            onChange={(e) =>
                            setMainAreaSettings({ ...mainAreaSettings, textColor: e.target.value })
                            }
                            fullWidth
                            sx={{
                                fontSize: "14px",
                                flex: 1,
                                "& .MuiInputBase-root": {
                                height: "35px",
                                fontSize: "14px",
                                },
                                "& .MuiInputLabel-root": {
                                fontSize: "12px",
                                },
                            }}
                        />
                        </Box>
                    </Grid>
                    </Grid>
                </Grid>
                {/* Body Styling */}
                 <Grid item xs={12}  sx={{ mt: 2, border: '1px solid #d2cece', padding:'3%', borderRadius:'12px'}}>
                    <Grid item xs={12} >
                    <h6 style={{ fontWeight: 600, color: "#636161", letterSpacing:'0px' }}>
                        Body Styling
                    </h6>
                    </Grid>

                    {/* Title Section */}
                    <Grid item xs={12} className='py-2'>
                    <h6 style={{ fontWeight: 600, color: "#636161", letterSpacing:'0px', fontSize:'14px' }}>
                        Title
                    </h6>
                    </Grid>

                    <Grid container spacing={2} sx={{ mb: 2 }}>
                    {/* Font Size (Title) */}
                    <Grid item xs={12} sm={6}>
                        <TextField
                        select
                        label="Font Size (Title)"
                        size="small"
                        value={bodyStyling.subHeadingTitleSize}
                        onChange={(e) =>
                            setBodyStyling({ ...bodyStyling, subHeadingTitleSize: e.target.value })
                        }
                        fullWidth
                            sx={{
                            fontSize: "14px",
                            flex: 1,
                            "& .MuiInputBase-root": {
                            height: "35px",
                            fontSize: "14px",
                            },
                            "& .MuiInputLabel-root": {
                            fontSize: "12px",
                            },
                        }}
                        >
                        {fontSizes.map((size) => (
                            <MenuItem 
                            key={size} value={size}
                            >
                                {size.toUpperCase()}
                            </MenuItem>
                        ))}
                        </TextField>
                    </Grid>

                    {/* Title Text Color */}
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <input
                            type="color"
                            value={bodyStyling.subHeadingTitleColor}
                            onChange={(e) =>
                            setBodyStyling({ ...bodyStyling, subHeadingTitleColor: e.target.value })
                            }
                            style={{
                              width: "25px",
                              height: "25px", 
                              border: 'none',
                              cursor: "pointer", 
                              padding: "0px", 
                              background: "#ffffff",
                              boxShadow: "0 0 8px rgb(193 195 198 / 70%) "
                            }}
                        />
                        <TextField
                            label="Title Text Color"
                            size="small"
                            value={bodyStyling.subHeadingTitleColor}
                            onChange={(e) =>
                            setBodyStyling({ ...bodyStyling, subHeadingTitleColor: e.target.value })
                            }
                            fullWidth
                            sx={{
                                fontSize: "14px",
                                flex: 1,
                                "& .MuiInputBase-root": {
                                height: "35px",
                                fontSize: "14px",
                                },
                                "& .MuiInputLabel-root": {
                                fontSize: "12px",
                                },
                            }}
                        />
                        </Box>
                    </Grid>
                    </Grid>

                    {/* Description Section */}
                    <Grid item xs={12} className='py-1'>
                    <h6 style={{ fontWeight: 600, color: "#636161", letterSpacing:'0px', fontSize:'14px' }}>
                        Description
                    </h6>
                    </Grid>

                    <Grid container spacing={2} sx={{ mb: 2 }}>
                    {/* Font Size (Description) */}
                    <Grid item xs={12} sm={6}>
                        <TextField
                        select
                        label="Font Size (Description)"
                        size="small"
                        value={bodyStyling.subHeadingDescSize}
                        onChange={(e) =>
                            setBodyStyling({ ...bodyStyling, subHeadingDescSize: e.target.value })
                        }
                        fullWidth
                            sx={{
                            fontSize: "14px",
                            flex: 1,
                            "& .MuiInputBase-root": {
                            height: "35px",
                            fontSize: "14px",
                            },
                            "& .MuiInputLabel-root": {
                            fontSize: "12px",
                            },
                        }}
                        >
                        {fontSizes.map((size) => (
                            <MenuItem 
                            key={size} value={size}
                            
                            >
                                {size.toUpperCase()}
                            </MenuItem>
                        ))}
                        </TextField>
                    </Grid>

                    {/* Description Text Color */}
                    <Grid item xs={12} sm={6}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                        <input
                            type="color"
                            value={bodyStyling.subHeadingDescColor}
                            onChange={(e) =>
                            setBodyStyling({ ...bodyStyling, subHeadingDescColor: e.target.value })
                            }
                            style={{
                              width: "25px",
                              height: "25px", 
                              border: 'none',
                              cursor: "pointer", 
                              padding: "0px",
                              background: "#ffffff",
                              boxShadow: "0 0 8px rgb(193 195 198 / 70%) "
                            }}
                        />
                        <TextField
                            label="Description Text Color"
                            size="small"
                            value={bodyStyling.subHeadingDescColor}
                            onChange={(e) =>
                            setBodyStyling({ ...bodyStyling, subHeadingDescColor: e.target.value })
                            }
                            fullWidth
                            sx={{
                                fontSize: "14px",
                                flex: 1,
                                "& .MuiInputBase-root": {
                                height: "35px",
                                fontSize: "14px",
                                },
                                "& .MuiInputLabel-root": {
                                fontSize: "12px",
                                },
                            }}
                        />
                        </Box>
                    </Grid>
                    </Grid>
                    </Grid>



                {/* Save Button */}
                <Grid item xs={12} className='pt-4 pb-2 flex' sx={{justifyContent:'center'}}>
                    <Button
                    variant="contained"
                    size="small"
                    onClick={()=>{handleConfigsettings()}}
                    >
                    Save Settings
                    </Button>
                </Grid>
                    </>
                )}

                </Grid>
            </Box>
            )}


            <StyledMenu
            id="demo-customized-menu"
            MenuListProps={{
                "aria-labelledby": "demo-customized-button",
            }}
            >
                <MenuItem
                disableRipple
                >
                <DeleteForeverIcon />
                Delete Post
                </MenuItem>
            </StyledMenu>
            <SidebarScheduling
                show={data.showScheduleSidebarModal} 
                close={handleScheduleModalClose}
                screen={currentScreen.ser_screen_id}
                schinfo={data.selectedSidebar} 
                refreshSidebar={getSidebarContent}
            />

            {/* For Dialog */}
            <Dialog open={addModalOpen} onClose={() => setAddModalOpen(false)} fullWidth maxWidth="sm">
                {/* <DialogTitle style={{paddingTop: "5%", paddingBottom: '0%'}}><h5 style={{fontWeight: 600, color:'#7e7e7e'}}>Add New Content For Sidebar</h5></DialogTitle> */}
                <DialogTitle style={{paddingTop: "5%", paddingBottom: '0%'}}>
                    <h5 style={{fontWeight: 600, color:'#7e7e7e'}}>
                        {isEditMode ? "Edit Sidebar Content" : "Add New Content For Sidebar"}
                    </h5>
                </DialogTitle>

                <DialogContent>
                    <TextField
                        label="Title"
                        fullWidth
                        margin="normal"
                        value={newContent.title}
                        rows={1}
                        onChange={handleTitleChange}
                    />
                    <TextField
                        label="Description"
                        fullWidth
                        multiline
                        rows={4}
                        margin="normal"
                        value={newContent.description}
                        // onChange={(e) =>
                        //     setNewContent({ ...newContent, description: e.target.value })
                        // }
                        onChange={handleDescriptionChange}
                        
                    />
                </DialogContent>

                <DialogActions style={{padding: "5%"}}>
                    <Button onClick={() => {
                        setAddModalOpen(false);
                        setIsEditMode(false);
                        setEditingId(null);
                        setNewContent({ title: "", description: "" });
                    }}>
                        Cancel
                    </Button>
                    <Button variant="contained" onClick={handleAddSubmit}>
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
    </>
  )
}
